/**
 * Shared streaming provider logos and helpers
 * Used by streaming-providers.jsx and tv-detail.jsx
 */

// Telia Play SVG Logo Component
export const TeliaPlayLogo = () => (
  <svg className="h-full w-auto" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 853.49 215.7">
    <path d="M145.78,0C80.33,0,0,43.14,0,98.18c0,43.14,58.02,117.52,101.16,117.52s104.13-68.43,104.13-163.63C205.29,13.39,177.02,0,145.78,0Zm23.82,120.64l-92.8,53.58c-9.34,5.39-21.01-1.35-21.01-12.13V54.93c0-10.78,11.67-17.52,21.01-12.13l92.8,53.58c9.34,5.39,9.34,18.87,0,24.26Z"></path>
    <path d="M327.29,76.17h-33.3v93.8h-21.1V76.17h-33.6v-18.3h88v18.3Z"></path>
    <path d="M390.69,135.47h-59c2.1,11.8,10.6,19.7,21.4,19.7,8.2,0,14.7-3.7,18.7-9.8l15.7,9.4c-8,10.7-21.1,17.1-34.4,17.1-21.9,0-41-17.4-41-42.4s18.9-42.2,40-42.2c27.7,.1,41.3,22.1,38.6,48.2Zm-58.4-14.9h39.4c-2.4-10.4-9.1-17-19.5-17-9.9,.1-17.2,6.8-19.9,17Z"></path>
    <path d="M432.59,170.17c-3,.6-6.2,.8-9.1,.8-14.1,0-20.3-6.7-20.3-20.3V57.87h19.7v90.1c0,6.9,4.2,7.8,9.8,7.2v15h-.1Z"></path>
    <path d="M442.79,67.17c0-6.2,5.4-11.4,11.7-11.4s11.5,5.1,11.5,11.4-5.4,11.4-11.5,11.4-11.7-5.2-11.7-11.4Zm1.8,102.7V89.87h19.7v80h-19.7Z"></path>
    <path d="M546.99,113.27v56.6h-18.4v-9.3c-6.2,8.2-16.2,11.2-24.5,11.2-17.3,0-27.5-10.9-27.5-24.5,0-15.5,17.4-28.2,38.7-28.2,4.2,0,8.6,.3,12.6,1.6v-5.3c0-8-4.6-12.2-14.1-12.2-8.5,0-16,4.3-20.6,9.9l-13.9-10.1c7.8-9.1,21.3-15.5,34.9-15.5,21.3,0,32.8,9.3,32.8,25.8Zm-19.1,25.7v-3.5c-3.2-1.1-6.6-1.4-10.7-1.4-14.4,0-21.8,5.8-21.8,12.8,0,5.8,5,9.4,12.5,9.4,10,0,20-5.9,20-17.3Z"></path>
    <path d="M589.33,57.86h37.85c21.15,0,38.17,15.36,38.17,36.32s-17.02,35.04-38.17,35.04h-24.17v40.64h-13.68V57.86Zm36.74,59.52c15.11,0,25.45-9.6,25.45-23.2s-10.34-24.48-25.45-24.48h-23.06v47.68h23.06Z"></path>
    <path d="M693.5,170.82c-11.61,0-16.38-6.08-16.38-18.08V57.86h12.88v94.24c0,8.48,5.25,8.48,10.66,7.84v10.08c-2.07,.48-4.77,.8-7.16,.8Z"></path>
    <path d="M762.52,158.66c-5.88,9.44-16.54,13.12-26.24,13.12-17.65,0-27.36-11.52-27.36-23.84,0-16,16.22-27.84,38.49-27.84,5.09,0,10.18,.48,14.47,1.76v-8c0-10.56-5.73-15.84-17.49-15.84-10.02,0-18.13,4.64-23.38,11.84l-9.22-6.72c6.68-9.12,19.24-15.68,32.76-15.68,19.24,0,29.9,9.28,29.9,24.16v58.24h-11.93v-11.2Zm-24.33,2.4c11.93,0,23.7-7.2,23.7-21.44v-7.68c-4.13-1.28-8.59-1.6-13.2-1.6-16.54,0-27.36,6.72-27.36,17.12,0,8.16,6.36,13.6,16.86,13.6Z"></path>
    <path d="M809.91,166.98l-31.33-77.12h13.68l24.17,61.92,24.02-61.92h13.04l-31.49,78.88c-8.75,21.92-17.65,29.92-26.88,34.4l-6.2-9.28c7-4.48,13.36-9.12,20.99-26.88Z"></path>
  </svg>
);

// Go3 Logo Component - PNG image
export const Go3Logo = () => (
  <img 
    src="/go3-logo.png" 
    alt="Go3" 
    className="w-full h-full object-contain"
  />
);

// Forum Cinemas Logo Component - PNG image
export const ForumCinemasLogo = () => (
  <img 
    src="/forum-cinema.png" 
    alt="Forum Cinemas" 
    className="w-full h-full object-contain"
  />
);

// Cinamon Logo Component - PNG image
export const CinamonLogo = () => (
  <img 
    src="/cinamon.png" 
    alt="Cinamon" 
    className="w-full h-full object-contain"
  />
);

// TV3 Play — brand wordmark (orange / white)
export const TV3PlayLogo = () => (
  <span className="flex flex-col items-center justify-center leading-none select-none">
    <span className="text-[#ff5f00] font-black tracking-tight text-lg">TV3</span>
    <span className="text-white text-[10px] font-semibold tracking-wide uppercase mt-0.5">Play</span>
  </span>
);

// Provider display names mapping
const PROVIDER_NAMES = {
  'teliaPlay': 'Telia Play',
  'go3': 'Go3',
  'tv3Play': 'TV3 Play',
  'forumCinemas': 'Forum Cinemas',
  'cinamon': 'Cinamon'
};

// Helper to get provider display name
export function getProviderDisplayName(providerId) {
  return PROVIDER_NAMES[providerId] || providerId;
}
